import { DCUIContent, DCUITheme } from '@iddataweb/idw-common-ui/types';
import { ButtonTypes } from "@enums/button-types";
import { DCUICaptureStepTypes } from "@enums/dcui-capture-step-types";
import {
    getCaptureStepInstructions,
    getCaptureStepLabel,
    getCaptureStepNativeCameraButtonText
} from "@utils/dcui-capture-step-util";
import { DCUIThemingOrientationPreviewContainer } from "../dcui-theming-orientation-preview-container/dcui-theming-orientation-preview-container";
import { DCUIThemingPrimaryButton } from "../dcui-theming-primary-button/dcui-theming-primary-button";
import styles from "./dcui-theming-capture-step-page.less";

type DCUIThemingCaptureStepPageProps = {
    stepType: DCUICaptureStepTypes;
    dcuiContent: DCUIContent;
    dcuiTheme: DCUITheme;
};

export const DCUIThemingCaptureStepPage = (props: DCUIThemingCaptureStepPageProps) => {
    const { stepType, dcuiContent, dcuiTheme } = props;

    const showQualityAdviceMessage = [
        DCUICaptureStepTypes.DRIVER_LICENSE_FRONT,
        DCUICaptureStepTypes.DRIVER_LICENSE_BACK,
        DCUICaptureStepTypes.ID_CARD_BACK,
        DCUICaptureStepTypes.ID_CARD_FRONT
    ].includes(stepType);

    const qualityAdviceMessage = dcuiContent.general.qualityAdviceMessage;

    return (
        <div className={styles.dcuiThemingCaptureStepPage}>
            <h1 id="capture-label">{getCaptureStepLabel(stepType, dcuiContent)}</h1>
            <>
                <div className={styles.stepInstructions}>
                    <span dangerouslySetInnerHTML={{ __html: getCaptureStepInstructions(stepType, dcuiContent) }} />
                </div>
                {showQualityAdviceMessage && (
                    <div className={styles.qualityAdviceMessage}>
                        <span>{qualityAdviceMessage}</span>
                    </div>
                )}
                <DCUIThemingOrientationPreviewContainer
                    stepType={stepType}
                    dcuiContent={dcuiContent}
                />
                <div className={styles.nativeCaptureContainer}>
                    <div className={styles.buttonContainer}>
                        <DCUIThemingPrimaryButton
                            disabled={false}
                            label={getCaptureStepNativeCameraButtonText(stepType, dcuiContent)}
                            type={ButtonTypes.BUTTON}
                            automationId={"start-capture"}
                            id={"start-capture"}
                            hideSpinner={true}
                            generalTheme={dcuiTheme.general}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};